/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export const mapRouteToRelativePath = (route: string): string =>
  `${route.startsWith("/") ? "" : "/"}${route}`;

export const getRoute = (...directories: (string | number)[]): string => {
  const route: string = directories.join("/").replace(/\/+/g, "/");
  return mapRouteToRelativePath(route);
};

export const getRelativeRouteWithQueryParams = (
  route?: string,
  queryParams?:
    string[][] | Record<string, string> | string | URLSearchParams | { [key: string | number]: any }
): string => {
  const queryParamStr: string | undefined =
    queryParams && new URLSearchParams(queryParams).toString();
  const pathname: string = route ? mapRouteToRelativePath(route) : "";
  const search: string = queryParamStr ? `?${queryParamStr}` : "";
  return `${pathname}${search}`;
};

export const getQueryParamValue = (url: string, queryParam: string): string | undefined => {
  const matches: RegExpExecArray | null = new RegExp(`${queryParam}=([^&]*)`).exec(url);
  return matches?.[1] ?? undefined;
};
